import { FC } from "react";

import { FIELD_TYPE_IDS } from "@ryde/shared";

import { FilterFreeTextReport } from "./filter-free-text.report";
import { FilterNumberBetweenReport } from "./filter-number-between.report";
import { FilterNumberComparisonReport } from "./filter-number-comparison.report";
import { FilterTimeReport } from "./filter-time.report";
import { IFilterByIdsReportProps } from "./filters-by-ids.report.models";

export const FiltersByIdsReport: FC<IFilterByIdsReportProps> = ({
  templateKey,
  filterFieldTypeId,
  initialCheckedValues,
  onValuesChange,
  onRemove,
}) => {
  switch (filterFieldTypeId) {
    case FIELD_TYPE_IDS.FILTER.time:
      return (
        <FilterTimeReport
          templateKey={templateKey}
          filterFieldTypeId={filterFieldTypeId}
          initialCheckedValues={initialCheckedValues}
        />
      );
    case FIELD_TYPE_IDS.FILTER.number_between:
      return (
        <FilterNumberBetweenReport
          templateKey={templateKey}
          filterFieldTypeId={filterFieldTypeId}
          initialCheckedValues={initialCheckedValues}
        />
      );
    case FIELD_TYPE_IDS.FILTER.number_comparison:
      return (
        <FilterNumberComparisonReport
          templateKey={templateKey}
          filterFieldTypeId={filterFieldTypeId}
          initialCheckedValues={initialCheckedValues}
        />
      );
    case FIELD_TYPE_IDS.FILTER.free_text:
      return (
        <FilterFreeTextReport
          templateKey={templateKey}
          filterFieldTypeId={filterFieldTypeId}
          initialCheckedValues={initialCheckedValues}
          onValuesChange={onValuesChange}
          onRemove={onRemove}
        />
      );
    default:
      return null;
  }
};
